import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import {
  BASE_URL_SANDBOX,
  GET_HIGHEST_SELLING_PRODUCTS,
} from '../../../Constants/Config';

const initialState = {
  loading: false,
  highestSellingProductsData: [],
  activeRequestId: null,
  error: '',
};

export const fetchHighestSellingProducts = createAsyncThunk(
  'highestSellingProducts/fetchHighestSellingProducts',
  async (data) => {
    const response = await axios.post(
      BASE_URL_SANDBOX + GET_HIGHEST_SELLING_PRODUCTS,
      data,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
    if (response.data.status === 200) {
      return response.data.result.highest_selling_products_data;
    }
  },
);

const highestSellingProductsSlice = createSlice({
  name: 'highestSellingProducts',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchHighestSellingProducts.pending, (state, action) => {
      state.loading = true;
      state.activeRequestId = action.meta.requestId;
      state.highestSellingProductsData = [];
    });
    builder.addCase(fetchHighestSellingProducts.fulfilled, (state, action) => {
      if (state.activeRequestId !== action.meta.requestId) return;

      state.loading = false;
      state.activeRequestId = null;
      state.highestSellingProductsData = action.payload || [];
      state.error = '';
    });
    builder.addCase(fetchHighestSellingProducts.rejected, (state, action) => {
      if (state.activeRequestId !== action.meta.requestId) return;

      state.loading = false;
      state.activeRequestId = null;
      state.highestSellingProductsData = [];
      state.error = action.error.message;
    });
  },
});

export default highestSellingProductsSlice.reducer;
